<script setup>
import {computed} from 'vue'
import {useUserStore} from '@/stores/user'
import {useViewStore} from '@/stores/view'

import Button from '@/common/Button.vue'

const props = defineProps({
    viewId: String,
    id: Number,
    selectMode: Boolean,
})

const viewStore = useViewStore(props.viewId)

const userStore = useUserStore()

const tableName = computed(() => viewStore.tableName || '')

const hasAccess = computed(() => {
    if (
        tableName.value.indexOf('product_variations__') === 0 ||
        props.selectMode
    ) {
        return false
    }

    return userStore.access(tableName.value, 'edit')
})

// Methods
const edit = () => {
    window.location = '/#/' + tableName.value + '/' + props.id
}
</script>

<template>
    <Button v-if="hasAccess" class="btn-sm" @click="edit">Edit</Button>
</template>